import type { NextPage } from "next";
import Head from "next/head";
import About from "../Components/About";
import "../i18n";
const AboutUs: NextPage = () => {
  return (
    <div>
      <Head>
        <title>Excel Technologies - About</title>
      </Head>
      <About />
    </div>
  );
};

export default AboutUs;
